//import "sitecss/site.css";
//import "sitecss/docutrack.css";
import * as util from "./docutrack";
import * as qtipval from "./jquery.qtip.validation";
import "toastr";

declare global {
    interface Window {
        DoNotInitQtipVal?: boolean;
    }
}

function innerInit() {
    Object.assign(window, util);
    Object.assign(window, qtipval);
    if (!window.DoNotInitQtipVal) qtipval.qTipValInit();
}

innerInit();
